<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <li v-for="(item, index) in breadcrumbs" :key="index" class="breadcrumb-item"
                :class="{ active: index === breadcrumbs.length - 1 }">
                <router-link v-if="index !== breadcrumbs.length - 1" :to="item.to">
                    {{ item.text }}
                </router-link>
                <span v-else>{{ item.text }}</span>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    computed: {
        breadcrumbs() {
            // router.meta.breadcrumb může být funkce, pokud chceš dynamické texty
            const route = this.$route;
            if (!route.meta.breadcrumb) return [];
            // pokud je text funkce (např. získání slug), zavoláme ji
            return route.meta.breadcrumb.map(b => ({
                text: typeof b.text === 'function' ? b.text(route) : b.text,
                to: b.to
            }));
        }
    }
}
</script>

<style>
.breadcrumb {
    padding: 0.5rem 1rem;
    background: none;
    margin-bottom: 1rem;
}
</style>
